var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToRightColorful(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.66613 10.8333L1.66602 9.16675H15.1426L11.8512 5.87529L13.0297 4.69678L18.333 10.0001L13.0297 15.3034L11.8512 14.1248L15.1427 10.8334L1.66613 10.8333Z",
    fill: "url(#paint0_linear_4809_575)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4809_575",
    x1: 2.75299,
    y1: 7.34335,
    x2: 9.15867,
    y2: 17.4091,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.443482,
    stopColor: "#FFAA48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.924797,
    stopColor: "#2F5CFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToRightColorful);
export default __webpack_public_path__ + "static/media/toRightColorful.1d9c9c9bfbd81bc82947f88c02293f53.svg";
export { ForwardRef as ReactComponent };